import _ from 'underscore';

import { EVENT_ID_FIELD, EVENT_PARAMS_FIELD, PARAM_EVENT_ID_FIELD, PARAM_ID_FIELD, EVENT_GEN_DATE_FIELD } from '../utils/constants';
const DEFAULT_LOCATION_REDUCER = {
  locations: [],
  params: new Map(),
  lastFetchDate: undefined
};

const locationReducer = (state, action) => {
  switch (action.type) {
    case "FETCH_GPS_JSON":{
       return { gps: [...action.data.data], ...state};
    }

    case "FETCH_LOCATIONS": {
      action.data.items = action.data.items.filter(i => i);
      const lastFetchDate = action.data.items.length === 0 ? state.lastFetchDate : action.data.items[action.data.items.length - 1][EVENT_GEN_DATE_FIELD];
      const locationsDup = [...state.locations, ...action.data.items];
      const locations = _.uniq(locationsDup, EVENT_GEN_DATE_FIELD).sort((a,b) => (a[EVENT_GEN_DATE_FIELD] > b[EVENT_GEN_DATE_FIELD]) ? 1 : -1);

      return { ...state, locations, lastFetchDate };
    }

    case "FETCH_LOCATION_PARAMS": {
      state.params.set(action.data[EVENT_ID_FIELD], action.data);
      return { ...state };
    }

    case "FETCH_PHOTOS":
    case "FETCH_IMPORTANT_PLACES": {
      if (action.data.items.length === 0)
        return state;
      let added = false;
      _.each(action.data.items, item => {
        const locId = item[PARAM_EVENT_ID_FIELD];
        let newLocationParams = [item];
        if (state.params.has(locId)) {
          if (!_.contains(_.map(state.params.get(locId), p => p[PARAM_ID_FIELD]), item[PARAM_ID_FIELD])) {
            newLocationParams = [...newLocationParams, ...state.params.get(locId)];
            state.params.set(locId, newLocationParams);
            added = true;
          }
        } else {
          state.params.set(locId, newLocationParams);
        }
      });
      return added ? { ...state } : state;
    }

    case "CLEAR_LOCATIONS":
      return { ...state, locations: [], lastFetchDate: undefined }
    default:
      return state;
  }
}

const getFullLocation = (locationReducer, location) => {
  const params = locationReducer.params.get(location[EVENT_ID_FIELD]);
  return { ...location, [EVENT_PARAMS_FIELD]: params };
};

const getFullLocations = locationReducer => {
  return _.map(locationReducer.locations, l => getFullLocation(locationReducer, l));
};

export { locationReducer as default, DEFAULT_LOCATION_REDUCER, getFullLocation, getFullLocations }